export default __webpack_public_path__ + "assets/tajikistan-flag.png";